import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AddCompanyModal = ({ clientId, onClose, onSuccess }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const [name, setName] = useState('');

  const handleSubmit = async () => {
    try {
      await axios.post(`${API}/companies`, { name, client_id: clientId });
      toast.success(t('success'));
      onSuccess();
      onClose();
    } catch { toast.error(t('error')); }
  };

  return (
    <div className="p-4 border-2 border-dashed border-slate-200 rounded-xl space-y-3 bg-slate-50">
      <div>
        <Label className="text-slate-700">{t('companyName')} <span className="text-red-500">*</span></Label>
        <Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1" />
      </div>
      <div className={`flex gap-2 ${isRTL ? 'flex-row-reverse justify-end' : ''}`}>
        <Button size="sm" onClick={handleSubmit} className="bg-[#D4AF37] hover:bg-[#B8960C] text-[#0F172A]">{t('save')}</Button>
        <Button size="sm" variant="outline" onClick={onClose}>{t('cancel')}</Button>
      </div>
    </div>
  );
};
